// extracted by mini-css-extract-plugin
export default {"section":"CtaComp_section__vEgYT","ctaPanel":"CtaComp_ctaPanel__2UNio","kicker":"CtaComp_kicker__XhTh7","ctaButton":"CtaComp_ctaButton__tj5Kp"};